export default __webpack_public_path__ + "static/media/sonenef-img.72a374af.png";